import { Dispatch, FC } from "react";
import { SectionBody, SectionHeaderCustom } from "@landtechnologies/components";
import { logEvent } from "react-migration/lib/util/logEvent";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import type { SiteFeature } from "src/js/stores/siteGeometry/store";
import type { SaveSiteLayer } from "../../typings";

interface PartOfSiteProps {
  layer: SaveSiteLayer;
  sites?: SiteFeature[];
  setSelectedSite: Dispatch<SiteFeature>;
}

export const PartOfSite: FC<PartOfSiteProps> = ({ layer, sites, setSelectedSite }) => {
  const { t } = useTranslation();
  if (!sites || !sites.length) return null;
  return (
    <div className="atlas-bg-white atlas-mb-3 atlas-overflow-hidden">
      <SectionHeaderCustom
        title="Part of site"
        className="atlas-py-2 atlas-px-3 atlas-rounded-t atlas-bg-background-light"
      >
        {t("sidebar.ownership_sidebar.part_of_site")}
      </SectionHeaderCustom>
      <SectionBody>
        {sites.map((site) => (
          <button
            key={site.id}
            title={site.properties.title}
            className="atlas-w-full atlas-border-t atlas-border-solid atlas-px-3 atlas-py-1.5 atlas-border-neutral-200 hover:atlas-bg-neutral-100 atlas-flex atlas-items-center atlas-justify-between atlas-text-left atlas-text-content-link hover:atlas-text-content-link-hover"
            onClick={() => {
              logEvent("Part of Saved Site Click", { layer, id: site.id });
              setSelectedSite(site);
            }}
          >
            <span className="atlas-truncate">{site.properties.title}</span>
          </button>
        ))}
      </SectionBody>
    </div>
  );
};
